<template>
  <div class="body bank-app" :dir="isRTL ? 'rtl' : 'ltr'">
    
    <Navbar 
      :showBackButton="true" 
      @back="goBack"
    />

    <div class="main-content">
      <!-- Card Services Section -->
      <div class="horizontal-services-section">

        <h3 class="section-title">
          {{ $t('dashboard.commonServices') }}
        </h3>

        <div class="horizontal-scroll-container">
          <div class="scroll-content">
            <div v-if="hasPermission('ASoratHesab')" class="scroll-service-item" @click="navigateCustomerSearchSoratHesab">
              <div class="scroll-service-icon">
                <img src="@/assets/Icons/searchCustomer.png" />
              </div>
              <span class="scroll-service-label">
                {{ $t('employer.dashboard.services.customerInvoice') }}
              </span>
            </div>

            <div v-if="hasPermission('SubmitFactorCustomer')" class="scroll-service-item" @click="navigateCustomerSearchStore">
              <div class="scroll-service-icon">
                <img src="@/assets/Icons/searchCustomer.png" />
              </div>
              <span class="scroll-service-label">
                {{ $t('dashboard.customerStore') }}
              </span>
            </div>
            <div v-if="hasPermission('AKardexKala')" class="scroll-service-item" @click="navigateKalaSearch">
              <div class="scroll-service-icon">
                <img src="@/assets/Icons/product.png" />
              </div>
              <span class="scroll-service-label">
                {{ $t('employer.dashboard.services.kalaSearch') }}
              </span>
            </div>
          </div>
        </div>

        <div class="horizontal-scroll-container">
          <div class="scroll-content">
            <div v-if="hasPermission('AReportMande')" class="scroll-service-item" @click="navigateMande">
              <div class="scroll-service-icon">
                <img src="@/assets/Icons/reportMande.png" />
              </div>
              <span class="scroll-service-label">
                {{ $t('employer.dashboard.services.balanceReport') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import Navbar from '@/components/Navbar.vue'
import { useRouter } from 'vue-router'

export default {
  name: 'BankDashboard',
  components: {
    Navbar,
  },
  setup() {
    const authStore = useAuthStore()
    const router = useRouter()
    const goBack = () => router.push('/select-role')

    const navigateCustomerSearchStore = () => {
      router.push('/accountant/customer-search-store')
    }

    const navigateCustomerSearchSoratHesab = () => {
      router.push('/accountant/customer-search-sorat')
    }

    const navigateKalaSearch = () => router.push('/accountant/kala-search')
    const navigateMande = () => router.push('/accountant/report-mande')


    const hasPermission = (permissionKey) => {
      console.log(authStore.permissions)
      return authStore.permissions.includes(permissionKey)
    }

    onMounted(async () => {
      if (authStore.isAuthenticated.value) {
        console.log("User is authenticated, fetching accounting data...")
      }
    })

    return {
      goBack,
      navigateCustomerSearchStore,
      navigateCustomerSearchSoratHesab,
      navigateKalaSearch,
      navigateMande,
      hasPermission
    }
  }
}
</script>

<style scoped>
.bank-app {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: var(--bg);
  color: var(--text);
  direction: rtl;
}

.main-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  padding-bottom: 80px; /* Space for bottom navigation */
}

.account-summary-dashboard {
  background: linear-gradient(135deg, #4a6baf, #2c4a8c);
  color: var(--text);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.account-type {
  font-size: 16px;
  margin-bottom: 8px;
  opacity: 0.9;
}

.account-balance {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.balance-label {
  font-size: 14px;
  opacity: 0.8;
}

.balance-amount {
  font-size: 18px;
  font-weight: bold;
  margin-left: auto;
  margin-right: auto;
}

.section-title {
  font-size: 16px;
  margin: 20px 0 12px;
  color: var(--text);
  font-weight: 600;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 20px;
}

.service-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.service-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-size: 12px;
  color: #4a6baf;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.service-label {
  font-size: 12px;
  color: #555;
}

.additional-text {
  background-color: white;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  color: #555;
}

.account-number {
  margin-top: 8px;
  font-weight: bold;
  color: #4a6baf;
}

/* Horizontal Scroll Services */
.horizontal-services-section {
  margin-bottom: 24px;
}

.horizontal-scroll-container {
  overflow-x: auto;
  padding: 8px 0;
  margin: 0 -16px;
  padding: 8px 16px;
}

.horizontal-scroll-container::-webkit-scrollbar {
  display: none;
}

.scroll-content {
  display: flex;
  gap: 16px;
  padding: 4px 0;
  min-width: min-content;
}

.scroll-service-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-width: 80px;
  flex-shrink: 0;
  margin-right: auto;
  margin-left: auto;
}

.scroll-service-item:hover {
  transform: scale(1.2);
  cursor: pointer;
  background-color: var(--hover);
  transform: translateY(-2px);
}

.scroll-service-item:active {
  transform: translateY(0);
}

.scroll-service-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  background:var(--card-bg);
  border:1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-size: 12px;
  color: #4a6baf;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden; /* Prevent image overflow */
}

.scroll-service-icon img {
  max-width: 70%; /* Limit image to 70% of container */
  max-height: 70%; /* Limit image to 70% of container */
  object-fit: contain; /* Maintain aspect ratio */
}

.scroll-service-label {
  font-size: 11px;
  color: var(--text);
  line-height: 1.3;
  max-width: 80px;
}

/* Original Services List */
.services-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.service-card {
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.service-card .card-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
  font-size: 12px;
  color: #4a6baf;
  font-weight: bold;
}

.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  background-color: white;
  padding: 12px 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  color: #555;
}

.nav-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 4px;
  background-color: #e9ecef;
  border-radius: 50%;
}

.home-icon {
  background-color: #4a6baf;
}

.services-icon, .cards-icon, .profile-icon {
  background-color: #e9ecef;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .services-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
  }
  
  .service-icon {
    width: 50px;
    height: 50px;
    font-size: 10px;
  }
  
  .service-label {
    font-size: 10px;
  }

  .scroll-service-icon {
    width: 55px;
    height: 55px;
    font-size: 11px;
  }

  .scroll-service-label {
    font-size: 10px;
    max-width: 70px;
  }
}

.accounting-section {
  margin-bottom: 24px;
}

.accounting-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.accounting-card {
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.accounting-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.record-date {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.record-amount {
  font-size: 14px;
  font-weight: bold;
}

.record-amount.debit {
  color: #e74c3c; /* Red for debit */
}

.record-amount.credit {
  color: #27ae60; /* Green for credit */
}

.card-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.record-detail {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
}

.detail-label {
  font-size: 11px;
  color: #888;
  font-weight: 500;
  min-width: 60px;
}

.detail-value {
  font-size: 12px;
  color: #333;
  text-align: left;
  flex: 1;
}

.type-badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
}

.debit-badge {
  background-color: #ffeaea;
  color: #e74c3c;
}

.credit-badge {
  background-color: #e8f7ef;
  color: #27ae60;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #666;
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #4a6baf;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 12px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.empty-state {
  text-align: center;
  padding: 40px;
  color: #888;
  background: white;
  border-radius: 12px;
  border: 1px dashed #ddd;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .accounting-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .accounting-card {
    padding: 12px;
  }
  
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .record-amount {
    align-self: flex-end;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .accounting-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1025px) {
  .accounting-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Existing styles remain below */
.bank-app {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: var(--bg);
  color: var(--text);
  direction: rtl;
}

.main-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  padding-bottom: 80px; /* Space for bottom navigation */
}

.account-summary-dashboard {
  background: var(--card-bg);
  border:1px solid var(--border);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.account-type {
  font-size: 16px;
  margin-bottom: 8px;
  opacity: 0.9;
  color:var(--text-muted);
}

.account-balance {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.balance-label {
  font-size: 14px;
  opacity: 0.8;
}

.balance-amount {
  font-size: 18px;
  font-weight: bold;
}
/* جزییات Button Styles */
.accounting-card .card-body button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 8px;
}

.accounting-card .card-body button:hover {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.accounting-card .card-body button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.accounting-card .card-body button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.3);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.4);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.request-modal {
  width: 90%;
  max-width: 480px;
  background: var(--bg);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.25);
  direction: rtl;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: var(--opposite-bg);
}

.form-row {
  margin: 12px 0;
  display: flex;
  flex-direction: column;
}

.form-row label {
  margin-bottom: 4px;
  font-weight: bold;
}

.form-row input,
.form-row select {
  padding: 10px;
  border:1px solid var(--border);
  background:var(--bg);
  color:var(--text);
    border-radius: 8px;
  font-size: 14px;
}

.modal-footer {
  text-align: center;
  margin-top: 15px;
}

.submit-btn {
  background: #2b57ff;
  color: white;
  padding: 10px 22px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 15px;
}
.back-arrow {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.back-arrow:hover {
  background-color: #f0f0f0;
}

.btn-primary{
  background:var(--primary);
  color:#fff;
  border:none;
  padding:8px 14px;
  border-radius:6px;
  cursor:pointer;
}

.btn-secondary{
  background:var(--card-bg);
  border:1px solid var(--border);
  padding:8px 14px;
  border-radius:6px;
  cursor:pointer;
}

/* Request Money Modal Styles */
.request-modal {
  width: 92%;
  max-width: 500px;
  background: var(--card-bg);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.25);
  direction: rtl;
  max-height: 90vh;
  overflow-y: auto;
}

/* Customer Status Display */
.customer-status {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-radius: 12px;
  margin-bottom: 20px;
  background: var(--bg);
  border: 1px solid var(--border);
  transition: all 0.3s ease;
  margin-top: 15px;
}

.customer-status.status-bes {
  border-right: 4px solid #f59e0b;
  background: #fffbeb;
}

.customer-status.status-bed {
  border-right: 4px solid #10b981;
  background: #ecfdf5;
}

.customer-status.status-zero {
  border-right: 4px solid #6b7280;
  background: #f9fafb;
}

.status-icon {
  font-size: 28px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--card-bg);
  flex-shrink: 0;
}

.status-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.status-label {
  font-size: 15px;
  color: var(--text-muted);
}

.status-value {
  font-size: 16px;
  font-weight: 600;
  color: var(--text);
}

.status-amount {
  font-size: 18px;
  font-weight: 700;
  color: var(--text);
}

.status-bes .status-amount {
  color: #d97706;
}

.status-bed .status-amount {
  color: #059669;
}

/* Form Rows */
.form-row {
  margin: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-row label {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
}

.form-row input,
.form-row select,
.form-row textarea {
  padding: 10px 14px;
  border: 1px solid var(--border);
  background: var(--bg);
  color: var(--text);
  border-radius: 10px;
  font-size: 14px;
  transition: all 0.2s ease;
  width: 100%;
}

.form-row input:focus,
.form-row select:focus,
.form-row textarea:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.1);
}

.readonly-input {
  background: var(--bg) !important;
  opacity: 0.8;
  cursor: default;
}

/* Amount Input */
.amount-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.amount-input {
  flex: 1;
  padding: 10px 14px !important;
  padding-left: 50px !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  text-align: center;
  direction: ltr;
}

.amount-input.readonly-amount {
  background: #fffbeb !important;
  border-color: #f59e0b !important;
  color: #d97706 !important;
}

.currency-label {
  position: absolute;
  left: 12px;
  font-size: 14px;
  color: var(--text-muted);
  font-weight: 500;
}

.amount-hint {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  margin-top: 4px;
  background: #fffbeb;
  border-radius: 8px;
  border: 1px solid #fde68a;
  font-size: 13px;
  color: #92400e;
}

.hint-icon {
  font-size: 16px;
}

/* Reason Select */
.reason-select {
  cursor: pointer;
}

/* Custom Reason Textarea */
.custom-reason-input {
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
}

/* Modal Footer */
.modal-footer {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid var(--border);
}

.cancel-btn {
  padding: 10px 20px;
  background: var(--bg);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.cancel-btn:hover {
  background: var(--hover);
}

.submit-btn {
  padding: 10px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Responsive */
@media (max-width: 480px) {
  .request-modal {
    padding: 16px;
  }

  .customer-status {
    padding: 12px;
    flex-wrap: wrap;
  }

  .status-icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }

  .status-amount {
    font-size: 16px;
  }

  .amount-input {
    font-size: 16px !important;
  }

  .modal-footer {
    flex-direction: column;
  }

  .modal-footer button {
    width: 100%;
    justify-content: center;
  }
}

/* Dark mode support */
[data-theme="dark"] .customer-status.status-bes {
  background: #1c1917;
  border-color: #f59e0b;
}

[data-theme="dark"] .customer-status.status-bed {
  background: #064e3b;
  border-color: #10b981;
}

[data-theme="dark"] .customer-status.status-zero {
  background: #1f2937;
  border-color: #6b7280;
}

[data-theme="dark"] .amount-hint {
  background: #1c1917;
  border-color: #f59e0b;
  color: #fbbf24;
}

[data-theme="dark"] .amount-input.readonly-amount {
  background: #1c1917 !important;
  border-color: #f59e0b !important;
  color: #fbbf24 !important;
}
.modal-footer1 {
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid var(--border);
  direction: ltr;
}

.cancel-btn1 {
  flex: 0 0 25%; /* 25% width */
  padding: 10px 20px;
  background: var(--bg);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
}

.cancel-btn1:hover {
  background: var(--hover);
}

.submit-btn1 {
  flex: 0 0 75%; /* 75% width */
  padding: 10px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
}

.submit-btn1:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.submit-btn1:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}
</style>